import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';
import { useGetMedicareContractsQuery } from '../../../../../../services/ContractService';

const MedicareContractIdEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const { data: medicareContracts = [] } = useGetMedicareContractsQuery(
    { company: contract?.company || '' },
    { skip: !contract?.company }
  );

  const handleChange = (value: string) => {
    if (!contract) return;

    dispatch(updateSelectedContract({
      medicareBasedConfig: {
        ...contract.medicareBasedConfig,
        medicareContractId: value
      }
    }));
  };

  if (!contract) return null;

  // Hide the field if "Based on Medicare" is not checked
  if (!contract.medicareBasedConfig?.basedOnMedicare) {
    return null;
  }

  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel>Medicare Contract ID</InputLabel>
      <Select
        value={contract.medicareBasedConfig?.medicareContractId ?? 'N/A'}
        onChange={(e) => handleChange(e.target.value)}
        label="Medicare Contract ID"
        sx={{ backgroundColor: 'white' }}
      >
        <MenuItem value="N/A">Not Applicable</MenuItem>
        {medicareContracts.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MedicareContractIdEditor;